import { AddClientResponse, ClientData } from "@shared/types";
import Text from "common/Typography/Text";
import TextWithIcon from "common/Text/TextWithIcon";
import { ICON_TYPES } from "@shared/common/constants";
import AntCheckCircleFilled from "@ant-design/icons/CheckCircleFilled";
import styled from "styled-components";
import useMessage from "utils/hooks/useMessage";
import {
  getCreateAccountsSuccessMessage,
  getCreateSingleAccountSuccessMessage,
} from "@shared/features/onboarding/utils";

const useCreateAccountMessage = () => {
  const [messageApi, contextHolder] = useMessage();

  const getSuccessMessage = (
    response?: AddClientResponse,
    exchangesList?: string[]
  ) => {
    let resultMessage: string | JSX.Element | undefined;
    const exchangeAccountsList =
      response?.data.data.map((account: ClientData) => account.exchange) ||
      exchangesList;

    if (exchangeAccountsList?.length === 1)
      resultMessage = getCreateSingleAccountSuccessMessage(
        exchangeAccountsList[0]
      );
    else if (exchangeAccountsList?.length)
      resultMessage = (
        <MessageWrapper>
          <Text style={{ textAlign: "start" }}>
            <CheckCircleFilled style={{ marginRight: 8 }} />
            {getCreateAccountsSuccessMessage(exchangeAccountsList.length)}
          </Text>
          {exchangeAccountsList.map((exchange, index) => (
            <TextWithIcon
              key={index}
              iconType={ICON_TYPES.EXCHANGE}
              text={exchange}
              coinOrExchangeName={exchange}
              style={{ marginTop: 4 }}
            />
          ))}
        </MessageWrapper>
      );

    if (resultMessage) {
      const isString = typeof resultMessage === "string";
      messageApi.open({
        content: resultMessage,
        duration: isString ? undefined : 5,
        type: isString ? "success" : undefined,
      });
    }
  };
  return { getSuccessMessage, contextHolder, messageApi };
};

export default useCreateAccountMessage;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;
const CheckCircleFilled = styled(AntCheckCircleFilled)`
  color: ${(p) => p.theme.colors.lightGreen};
`;
